import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matInfo } from '@ng-icons/material-icons/baseline';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-info-notice',
  imports: [NgIcon, CommonModule, TranslateModule],
  viewProviders: [provideIcons({ matInfo })],
  templateUrl: './info-notice.component.html',
})
export class InfoNoticeComponent {
  text = input('');
  translateParams = input<Record<string, unknown>>();
  containerClass = input('');
}
